import { render, staticRenderFns } from "./beneficiary-customer.vue?vue&type=template&id=1ae16cd4&"
import script from "./beneficiary-customer.vue?vue&type=script&lang=js&"
export * from "./beneficiary-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports